(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-featured-articles"] && !Shopify.designMode) return;
  try {
    
  const list = document.getElementById('blog_list');
  const btn = document.getElementById('readMoreBtn');
  const visibleItemsInput = document.getElementById('visibleItemsCount');

  if (list && visibleItemsInput) {
    // Check if both the list and hidden input exist
    let visibleItems = parseInt(visibleItemsInput.value, 10); // Get value from hidden input
    const items = list.getElementsByTagName('li');

    btn.addEventListener('click', function () {
      let itemsToShow = 4; // Number of items to show on each click

      for (let i = visibleItems; i < visibleItems + itemsToShow; i++) {
        if (items[i]) {
          items[i].classList.add('show');
        }
      }

      visibleItems += itemsToShow;

      if (visibleItems >= items.length) {
        btn.style.display = 'none'; // Hide button when all items are shown
      }
    });
  } else {
    if (btn) btn.style.display = 'none'; // Hide button if necessary elements are not found
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured-articles"] && !Shopify.designMode) return;
  try {
    
  const list = document.getElementById('blog_list');
  const btn = document.getElementById('readMoreBtn');
  const visibleItemsInput = document.getElementById('visibleItemsCount');

  if (list && visibleItemsInput) {
    // Check if both the list and hidden input exist
    let visibleItems = parseInt(visibleItemsInput.value, 10); // Get value from hidden input
    const items = list.getElementsByTagName('li');

    btn.addEventListener('click', function () {
      let itemsToShow = 4; // Number of items to show on each click

      for (let i = visibleItems; i < visibleItems + itemsToShow; i++) {
        if (items[i]) {
          items[i].classList.add('show');
        }
      }

      visibleItems += itemsToShow;

      if (visibleItems >= items.length) {
        btn.style.display = 'none'; // Hide button when all items are shown
      }
    });
  } else {
    if (btn) btn.style.display = 'none'; // Hide button if necessary elements are not found
  }

  } catch(e) { console.error(e); }
})();
})();
